(function() {
  function initQuickView() {
    const buttons = document.querySelectorAll('[data-pm-quick-view]:not([data-pm-init])');
    buttons.forEach(btn => {
      btn.setAttribute('data-pm-init', 'true');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const handle = this.getAttribute('data-handle');
        if (handle) {
          openModal(handle);
        }
      });
    });
  }

  async function openModal(handle) {
    let modal = document.querySelector('.pm-quickview-modal');
    if (!modal) {
      document.body.insertAdjacentHTML('beforeend', `
        <div class="pm-quickview-modal" onclick="this.classList.remove('active'); document.body.style.overflow = '';">
          <div class="pm-quickview-modal-container" onclick="event.stopPropagation();">
            <div class="pm-quickview-modal-close" onclick="document.querySelector('.pm-quickview-modal').classList.remove('active'); document.body.style.overflow = '';">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#03334D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="pm-quickview-modal-inner">
              <div class="pm-quickview-loading">
                <div class="pm-quickview-spinner"></div>
              </div>
            </div>
          </div>
        </div>
      `);
      modal = document.querySelector('.pm-quickview-modal');
    }

    // Always re-attach event listeners to ensure they work even if modal was pre-rendered or modified
    const closeBtn = modal.querySelector('.pm-quickview-modal-close');
    if (closeBtn) {
      closeBtn.onclick = closeModal;
    }
    modal.onclick = backdropClick;

    const modalInner = modal.querySelector('.pm-quickview-modal-inner');
    modalInner.innerHTML = '<div class="pm-quickview-loading"><div class="pm-quickview-spinner"></div></div>';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    try {
      const response = await fetch(`/products/${handle}?section_id=pm-quickview-api`);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionContent = doc.querySelector('.shopify-section');
      
      if (sectionContent && sectionContent.innerHTML.trim() !== "") {
        modalInner.innerHTML = sectionContent.innerHTML;
        
        // Execute scripts manually as innerHTML doesn't run them
        const scripts = modalInner.querySelectorAll('script');
        scripts.forEach(oldScript => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        initSlider(modalInner);
        initVariants(modalInner);
        initForm(modalInner);
        initQuantity(modalInner);
      } else {
        // Fallback for some themes where shopify-section might be nested or named differently
        const content = doc.querySelector('.pm-quickview-content');
        if (content) {
          modalInner.innerHTML = content.outerHTML;
          
          // Execute scripts manually for fallback content
          const scripts = modalInner.querySelectorAll('script');
          scripts.forEach(oldScript => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });

          initSlider(modalInner);
          initVariants(modalInner);
          initForm(modalInner);
          initQuantity(modalInner);
        } else {
          throw new Error('Empty response');
        }
      }
    } catch (error) {
      console.error('Error fetching quick view:', error);
      modalInner.innerHTML = '<p class="pm-quickview-error">Error loading product data. Please try again.</p>';
    }
  }

  function backdropClick(e) {
    if (e.target.classList.contains('pm-quickview-modal') || e.target.classList.contains('pm-quickview-modal-container')) {
      closeModal();
    }
  }

  function closeModal() {
    const modal = document.querySelector('.pm-quickview-modal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  function initVariants(container) {
    const variantsJson = container.querySelector('[data-pm-quickview-variants-json]');
    if (!variantsJson) return;
    const variants = JSON.parse(variantsJson.innerHTML);
    const radioButtons = container.querySelectorAll('[data-pm-quickview-option]');
    const variantIdInput = container.querySelector('input[name="id"]');
    const atcButton = container.querySelector('.pm-quickview-atc');
    const sellingPlanContainer = container.querySelector('.pm-quickview-selling-plan-container');

    function formatMoney(cents) {
        if (window.themeVendor && themeVendor.themeCurrency && themeVendor.themeCurrency.formatMoney) {
            return themeVendor.themeCurrency.formatMoney(cents);
        } else if (window.Shopify && Shopify.formatMoney) {
            return Shopify.formatMoney(cents);
        } else {
            return '$' + (cents / 100).toFixed(2);
        }
    }

    function updateVariant() {
        const selectedOptions = {};
        container.querySelectorAll('[data-pm-quickview-option]:checked').forEach(radio => {
            selectedOptions[radio.getAttribute('data-pm-quickview-option')] = radio.value;
        });

        // Update OOS status for all options based on current selection
        container.querySelectorAll('[data-pm-quickview-option]').forEach(radio => {
            const radioOption = radio.getAttribute('data-pm-quickview-option');
            const radioValue = radio.value;
            const label = radio.closest('label');
            
            // Check if this specific option value exists in ANY available variant that matches OTHER currently selected options
            const isPossible = variants.some(variant => {
                if (!variant.available) return false;
                
                return Object.keys(selectedOptions).every(optionKey => {
                    if (optionKey === radioOption) return variant[optionKey.replace('data-pm-quickview-', '')] === radioValue;
                    return variant[optionKey.replace('data-pm-quickview-', '')] === selectedOptions[optionKey];
                });
            });

            if (isPossible) {
                label.classList.remove('pm-quickview-option-oos');
            } else {
                label.classList.add('pm-quickview-option-oos');
            }
        });

        const selectedVariant = variants.find(variant => {
            return Object.keys(selectedOptions).every(option => {
              const optKey = option.replace('data-pm-quickview-', '');
              return variant[optKey] === selectedOptions[option];
            });
        });

        if (selectedVariant) {
            // Update Variant ID
            variantIdInput.value = selectedVariant.id;

            // Update Price and ATC state
            if (selectedVariant.available) {
                atcButton.disabled = false;
                atcButton.classList.remove('oos');
                atcButton.innerText = 'Add To Cart';
            } else {
                atcButton.disabled = true;
                atcButton.classList.add('oos');
                atcButton.innerText = 'Sold Out';
            }

            // Update main price and compare price displays
            const mainPriceDisplay = container.querySelector('[data-total-price]');
            const comparePriceDisplay = container.querySelector('[data-compare-price]');
            
            // Check if subscription is selected
            const selectedPlanRadio = sellingPlanContainer ? sellingPlanContainer.querySelector('input[type="radio"]:checked') : null;
            const isSubscription = selectedPlanRadio && selectedPlanRadio.value !== 'one-time';

            // Update UI
            if (isSubscription) {
                const oneTimeEntry = sellingPlanContainer.querySelector('.pm-quickview-selling-plan-entry:not(.subscription)');
                if (oneTimeEntry) oneTimeEntry.setAttribute('data-plan-price', selectedVariant.price);

                // Re-trigger the change event on the selected radio to let selling plan script handle price update with discount
                selectedPlanRadio.dispatchEvent(new Event('change'));
            } else {
                const oneTimeEntry = sellingPlanContainer ? sellingPlanContainer.querySelector('.pm-quickview-selling-plan-entry:not(.subscription)') : null;
                if (oneTimeEntry) {
                    oneTimeEntry.setAttribute('data-plan-price', selectedVariant.price);
                    const oneTimeRadio = oneTimeEntry.querySelector('input');
                    if (oneTimeRadio && oneTimeRadio.checked) {
                        oneTimeRadio.dispatchEvent(new Event('change'));
                    }
                }

                if (mainPriceDisplay) mainPriceDisplay.innerText = formatMoney(selectedVariant.price);
                if (comparePriceDisplay) {
                    if (selectedVariant.compare_at_price > selectedVariant.price) {
                        comparePriceDisplay.innerText = formatMoney(selectedVariant.compare_at_price);
                        comparePriceDisplay.style.setProperty('display', 'block', 'important');
                    } else {
                        comparePriceDisplay.style.setProperty('display', 'none', 'important');
                    }
                }
            }
            
            // Dispatch event for other scripts to listen to variant changes (like the selling plan script)
            const modalInner = container.querySelector('.pm-quickview-modal-inner');
            if (modalInner) {
                modalInner.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: selectedVariant } }));
            }

            // Update images if variant has a featured image
            if (selectedVariant.featured_media && selectedVariant.featured_media.preview_image) {
                const slides = container.querySelectorAll('.pm-quickview-slide');
                const variantImgSrc = selectedVariant.featured_media.preview_image.src.split('/').pop().split('?')[0];
                const targetSlide = Array.from(slides).find(slide => {
                    const img = slide.querySelector('img');
                    return img && img.src.includes(variantImgSrc);
                });
                if (targetSlide) {
                    const index = parseInt(targetSlide.getAttribute('data-index'));
                    const dots = container.querySelectorAll('.pm-quickview-dot');
                    if (dots[index]) dots[index].click();
                }
            }
        }
    }

    radioButtons.forEach(radio => {
        radio.addEventListener('change', updateVariant);
    });

    updateVariant();
  }

  function initQuantity(container) {
    const minusBtn = container.querySelector('.pm-quickview-qty-minus');
    const plusBtn = container.querySelector('.pm-quickview-qty-plus');
    const input = container.querySelector('.pm-quickview-qty-input');
    
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', () => {
      let value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plusBtn.addEventListener('click', () => {
      let value = parseInt(input.value) || 1;
      input.value = value + 1;
      input.dispatchEvent(new Event('change'));
    });

    input.addEventListener('change', () => {
      let value = parseInt(input.value);
      if (isNaN(value) || value < 1) {
        input.value = 1;
      }
    });
  }

  function initSlider(container) {
    const slides = container.querySelectorAll('.pm-quickview-slide');
    const dots = container.querySelectorAll('.pm-quickview-dot');
    const prev = container.querySelector('.pm-quickview-slider-prev');
    const next = container.querySelector('.pm-quickview-slider-next');
    let currentIndex = 0;

    if (slides.length <= 1) return;

    function showSlide(index) {
      slides.forEach(s => s.classList.remove('active'));
      dots.forEach(d => d.classList.remove('active'));
      
      currentIndex = (index + slides.length) % slides.length;
      slides[currentIndex].classList.add('active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('active');
    }

    if (prev) prev.addEventListener('click', () => showSlide(currentIndex - 1));
    if (next) next.addEventListener('click', () => showSlide(currentIndex + 1));
    
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => showSlide(idx));
    });
  }
  window.SLIDECART_UPDATED = function() {
    closeModal();
  }
  function initForm(container) {
    const form = container.querySelector('#pm-quickview-form');
    if (!form) return;

    // Price update and footer logic is now handled in snippets/pm-selling-plan.liquid
    // which is rendered inside this form.
    
    // Re-init any theme specific components if needed
    if (window.theme && window.theme.ProductForm) {
      new theme.ProductForm(form);
    }

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const atcButton = form.querySelector('.pm-quickview-atc');
      if (atcButton) {
        atcButton.disabled = true;
        atcButton.classList.add('loading');
      }
      return;

      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        const data = await response.json();

        if (response.ok) {
          // Trigger cart drawer or update if the theme uses one
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: data }
          }));
          
          // Close modal
          closeModal();
          
          // Optional: Re-open if theme has a cart drawer
          if (window.theme && window.theme.cart) {
            // Some themes might need this to show the cart drawer
          }
        } else {
          console.error('Error adding to cart:', data.description);
          alert(data.description || 'Error adding to cart. Please try again.');
          if (atcButton) {
            atcButton.disabled = false;
            atcButton.classList.remove('loading');
          }
        }
      } catch (error) {
        console.error('Fetch error:', error);
        if (atcButton) {
          atcButton.disabled = false;
          atcButton.classList.remove('loading');
        }
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickView);
  } else {
    initQuickView();
  }

  // Watch for dynamic content changes (e.g., collection filters)
  let timeout;
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && (node.querySelector('[data-pm-quick-view]') || node.hasAttribute('data-pm-quick-view'))) {
            shouldInit = true;
            break;
          }
        }
      }
      if (shouldInit) break;
    }

    if (shouldInit) {
      clearTimeout(timeout);
      timeout = setTimeout(initQuickView, 200);
    }
  });

  const target = document.querySelector('.main-content') || document.body;
  observer.observe(target, { childList: true, subtree: true });
})();
